import 'script-loader!jquery';
// import 'script-loader!bootstrap';
// import 'script-loader!slick-carousel';
// import 'script-loader!sticky-scroll';
// import 'script-loader!smartmenus';
// import 'script-loader!./jquery.flip.js';
// import retina from 'retinajs';
// import velocity from 'velocity-animate';
// import fontawesome from '@fortawesome/fontawesome';
// import faSolid from '@fortawesome/fontawesome-free-solid';
// import faBrands from '@fortawesome/fontawesome-free-brands';
// import fancybox from '@fancyapps/fancybox';
// import 'smartmenus/dist/css/sm-core-css.css';
// import 'smartmenus/dist/css/sm-simple/sm-simple.scss';
// import 'slick-carousel/slick/slick.scss';
// import 'slick-carousel/slick/slick-theme.scss';
import '../scss/entry.scss';

jQuery(document).ready(function($) {
	$(document).ready(function() {
		// Tab click event
		$('.tab').on('click', function() {
			var targetTab = $(this).data('tab');
			
			// Remove active class from all tabs and tab contents
			$('.tab').removeClass('active');
			$('.tab-content').removeClass('active');
			
			// Add active class to the clicked tab and corresponding content
			$(this).addClass('active');
			$('#' + targetTab).addClass('active');
		});
	});
});